import React, { useState, useEffect, useCallback, useContext } from "react";
import axios from "axios";
import Spinner from "../../Components/Spinner";
import DataGridTable from "../../Components/DataGridTable";
import { BASE_URL_API } from "../../Constants";
import { useAuth } from "../../hooks/AuthProvider";
import { useNavigate } from 'react-router-dom';
import Alert from '../../Components/Alert';

import { LanguageContext } from "../../context/LanguageContext";
import AddIcon from "@mui/icons-material/Add";
import "../../Components/modal.css";
import "./UserHealthDetails.css";
import {
  getHealthTranslations,
  HealthPageHeader,
  PermissionDenied,
  isRtlLanguage,
} from "./userHealthShared";
export const MyHealth = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [starting, setStarting] = useState(false);
  const navigate = useNavigate();

  const { permissions } = useAuth();
  const { lang } = useContext(LanguageContext);
  const t = getHealthTranslations(lang);

  const canView = permissions["view_my_health_data"] || permissions["view_users_health"];
  const [openConfirm, setOpenConfirm] = useState(false);
  const isRtl = isRtlLanguage(lang);
  const { user } = useAuth();
  const pagingoptions = [10, 20, 50, 100];


  const columns = [
    {
      field: "userName",
      headerName: t.columns.user,
      width: 250,
      align: "center",
      headerAlign: "center"

    },
    {
      field: "weight",
      headerName: t.columns.weight,
      width: 150,
      align: "center",
      headerAlign: "center"

    },
    {
      field: "height",
      headerName: t.columns.height,
      width: 150,
      align: "center",
      headerAlign: "center"

    },
    {
      field: "bmi",
      headerName: t.columns.bmi,
      width: 120,
      align: "center",
      headerAlign: "center"

    },
    {
      field: "age",
      headerName: t.columns.age,
      width: 120,
      align: "center",
      headerAlign: "center"
    },
    {
      field: "gmtCreate",
      headerName: t.columns.createdAt,
      width: 200,
      align: "center",
      headerAlign: "center"


    },
  ];
  const [alertState, setAlertState] = useState({
    open: false,
    message: '',
    type: 'info',
    position: isRtl ? 'left' : 'right'
  });

  const showAlert = (type, message) => {
    setAlertState({
      open: true,
      type,
      message,
      position: isRtl ? 'left' : 'right'
    });
  };
  const fetchData = useCallback(async () => {
    if (!canView) return;

    setLoading(true);

    try {
      const res = await axios.get(`${BASE_URL_API}/user-health/my`);

      if (Array.isArray(res.data?.data)) {
        const formatted = res.data.data.map((item) => ({
          ...item,
          userName: item.user?.name || "",
        }));

        setRows(formatted);
      } else {
        setRows([]);
      }
    } catch (err) {
      console.error("UserHealth fetch error:", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [canView]);
  const handleRowClick = (params) => {
    navigate('/users-health/details/' + params.row.id);
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const handleStartScan = async () => {
    setOpenConfirm(false); 

    try {
      setStarting(true);

      const res = await axios.post(`${BASE_URL_API}/medical-device/start-scan`, {
        healthDeviceId: 1,
        userId: user?.id,
      });

      showAlert(
        'success',
        res.data?.INFO || t.actions.startScanTitle
      );

      fetchData();

    } catch (err) {
      const message =
        err?.response?.data?.INFO ||
        err?.response?.data?.message ||
        err.message ||
        t.actions.startScanTitle;

      showAlert('error', message);
    } finally {
      setStarting(false);
    }
  };
  if (!canView) {
    return (
      <PermissionDenied title={t.states.permissionDenied} message={t.states.cannotViewHealth} />
    );
  }

  return (
    <div className="configuration devices-page health-page" dir={isRtl ? "rtl" : "ltr"} style={{ height: "100%" }}>
      <div className="device-main health-page-shell">
        <HealthPageHeader
          title={t.pages.myHealth}
          subtitle={t.descriptions.myHealth}
          actions={
          <button className="devices-primary-btn" onClick={() => setOpenConfirm(true)}>
            <AddIcon style={{ marginInlineEnd: "8px" }} />
            <span>{t.actions.startScan}</span>
          </button>
          }
        />

        {openConfirm ? (
          <div id="modal" className="health-scan-modal-overlay" onMouseDown={() => setOpenConfirm(false)}>
            <div
              id="popup"
              className="dashboard-modal health-scan-modal"
              onMouseDown={(event) => event.stopPropagation()}
              role="dialog"
              aria-modal="true"
            >
              <div className="dashboard-header health-scan-modal__header">
                <div className="dashboard-header-text">
                  <h2>{t.actions.startScanTitle}</h2>
                </div>
              </div>
              <div className="modal-divider" />
              <div className="modal-content dashboard-content health-scan-modal__content">
                {t.actions.startScanConfirm}
              </div>
              <div className="modal-divider" />
              <div className="modal-footer dashboard-footer health-scan-modal__footer">
                <div className="modal-footer-right-buttons">
                  <button
                    type="button"
                    className="btn btn-cancel-details"
                    onClick={() => setOpenConfirm(false)}
                  >
                    {t.actions.cancel}
                  </button>
                  <button
                    type="button"
                    className="btn btn-apply"
                    onClick={handleStartScan}
                    disabled={starting}
                  >
                    {starting ? t.actions.starting : t.actions.confirmStart}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <Alert
          open={alertState.open}
          close={() => setAlertState({ ...alertState, open: false })}
          message={alertState.message}
          type={alertState.type}
          position={alertState.position}
        />
        {loading ? (
          <Spinner />
        ) : rows.length > 0 ? (
          <div className="table-wrapper" style={{ flex: 1 }}>
            <DataGridTable
              columns={columns}
              rows={rows}
              idcolumn={"id"}
              pagingoptions={pagingoptions}
              sortField="created_at"
              sortType="desc"
              showToolbar={true}
              tableKey="user_health"
              handleRowClick={handleRowClick}

            />
          </div>
        ) : (
          <div className="health-empty-state">{t.states.noData}</div>
        )}
      </div>
    </div>
  );
};
